import axios from "@configs/axios";

export const login = (data) => {
  return axios.post("/auth/jwt/create/", data);
};
